import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  Divider,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import SubscribeButton from "../../SubscribeButton";


interface FreeTierModalProps {
  userData: any;
  open: boolean;
  onClose: () => void;
}

export default function FreeTierModal({
  userData,
  open,
  onClose,
}: FreeTierModalProps) {
  const [selectedPlan, setSelectedPlan] = useState<string>("2fwt");
  const [, setShowAddPaymentDialog] = useState<boolean>(false);
  const [paymentMethodLoading, setPaymentMethodLoading] = useState<boolean>(false);

  const handlePlanChange = (
    event: React.MouseEvent<HTMLElement>,
    newPlan: string | null
  ) => {
    if (newPlan !== null) {
      setSelectedPlan(newPlan);
    }
  };

  const handleSubscriptionSuccess = () => {
    // Close the FreeTierModal
    onClose();
    // Optionally refresh the page or update app state to reflect the new subscription
    window.location.reload(); // This will refresh the entire app to reflect the subscription change
  };

  return (
    <Dialog
      open={open}
      onClose={() => {}} // Prevent manual closing until subscription is complete
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 3, p: 1 },
      }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1.5}>
          <WarningIcon color="warning" />
          <Typography variant="h6" fontWeight="600">
            Your Free Trial Has Ended
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          To continue using Stafflows, please choose a plan and add your payment
          information below.
        </Typography>

        <Divider sx={{ my: 2 }} />

        {/* Plan selection */}
        <Typography variant="subtitle1" fontWeight="600" sx={{ mb: 1 }}>
          Select Your Plan
        </Typography>
        <ToggleButtonGroup
          value={selectedPlan}
          exclusive
          onChange={handlePlanChange}
          fullWidth
          sx={{
            mb: 2,
            "& .MuiToggleButton-root": {
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 500,
            },
          }}
        >
          <ToggleButton value="v79p">Basic - $10/mo</ToggleButton>
          <ToggleButton value="2fwt">Pro - $30/mo</ToggleButton>
          <ToggleButton value="-">Business - $80/mo</ToggleButton>
        </ToggleButtonGroup>

        <Divider sx={{ my: 2 }} />

        {/* Subscription Button (Braintree Drop-in) */}
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1" fontWeight="600" sx={{ mb: 1 }}>
            Add Payment Method
          </Typography>

          <SubscribeButton
            planId={selectedPlan}
            userData={userData}
            setShowAddPaymentDialog={setShowAddPaymentDialog}
            paymentMethodLoading={paymentMethodLoading}
            setPaymentMethodLoading={setPaymentMethodLoading}
            canCancel={false}
            onSuccess={handleSubscriptionSuccess} // Pass the success callback
            subscribe={true}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
